var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLingua(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10.5,
    fill: "#7F9AE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5C10.1 6.5 9.2 9.1 9.2 12C9.2 14.9 10.1 17.5 12 19.5C13.9 17.5 14.8 14.9 14.8 12C14.8 9.1 13.9 6.5 12 4.5Z M4.5 12H19.5",
    stroke: "#FFFDFC",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLingua);
export default __webpack_public_path__ + "static/media/lingua.53549a25fc927f1f63b439625ee78588.svg";
export { ForwardRef as ReactComponent };